var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('v-server-table',{ref:"datatable",attrs:{"url":_vm.datatable.api,"name":_vm.datatable.name,"columns":_vm.datatable.columns,"options":_vm.datatable.options}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8a842c4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/pug-deps-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/franchise_component/setting/payment/settings-payment-datatable.vue
// module id = /Dph
// module chunks = 99